// extracted by mini-css-extract-plugin
export default {"menuBlock":"aF-z","title":"bF-z","nav":"cF-z","flexCell":"dF-z","facetLink":"eF-z"};